import { useQuery } from '@tanstack/react-query'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import { promoCodeKeys } from './query-keys'

const fetchExistingUsersTotal = async (referredOnly: boolean): Promise<number> => {
  try {
    const res = await AppAdmin.getDistributionExistingUsers({
      page: 1,
      limit: 10,
      referredOnly: referredOnly || undefined,
    })
    return res.data?.data?.totalResults ?? 0
  } catch (error) {
    logError('Error fetching existing users count:', error)
    return 0
  }
}

/**
 * "Total users in whitelist" figure: all KYC'd users, or only referred users
 * when the Referred users option is selected.
 */
export const useExistingUsersCount = (enabled: boolean, referredOnly = false) => {
  const query = useQuery({
    queryKey: promoCodeKeys.existingUsers(referredOnly ? '__count-referred__' : '__count__'),
    queryFn: () => fetchExistingUsersTotal(referredOnly),
    enabled,
    gcTime: 30000,
  })

  return { total: query.data, isLoading: query.isLoading }
}
